import { render, staticRenderFns } from "./User-Login.vue?vue&type=template&id=4acb3b06&scoped=true"
import script from "./User-Login.vue?vue&type=script&lang=js"
export * from "./User-Login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb3b06",
  null
  
)

export default component.exports